import { ITranslationEntry } from '../lang';

export const HR: ITranslationEntry = {
  translations: {
    notifications: 'Obavijesti',
    markAllAsRead: 'Označi sve kao pročitano',
    poweredBy: 'Uz podršku',
    settings: 'Postavke',
  },
  lang: 'hr',
};
